import api from '@/api/application'

const state = {
  candidateInfo: {}
}

const actions = {
  getUploadTaskHistory (context, params) {
    return api.getUploadTaskHistory(params)
  },
  getUploadToken () {
    return api.getUploadToken()
  },
  parseBatchUploadResume (context, params) {
    return api.parseBatchUploadResume(params)
  },
  getResumeParseResult (context, params) {
    return api.getResumeParseResult(params)
  },
  submitBatchOssParseResume (context, params) {
    return api.submitBatchOssParseResume(params)
  },
  getBatchOssParseResult (context, params) {
    return api.getBatchOssParseResult(params)
  },
  importBatchUploadedCandidate (context, params) {
    return api.importBatchUploadedCandidate(params)
  },
  uploadTaskFile (context, fileInfo) {
    return api.uploadTaskFile(fileInfo)
  },
  getLanguageList () {
    return api.getLanguageList()
  },
  getLanguageLevelList () {
    return api.getLanguageLevelList()
  },
  getLanguageCertificationList () {
    return api.getLanguageCertificationList()
  },
  getEducationLevelList () {
    return api.getEducationLevelList()
  },
  getAcademicRatingList () {
    return api.getAcademicRatingList()
  },
  getMajorList (context, params) {
    return api.getMajorList(params)
  },
  getSchoolList (context, params) {
    return api.getSchoolList(params)
  },
  getIndustryList () {
    return api.getIndustryList()
  },
  getChatToolList () {
    return api.getChatToolList()
  },
  getSocialNetworkList () {
    return api.getSocialNetworkList()
  },
  getJobFamilyList () {
    return api.getJobFamilyList()
  },
  parseCandidateResumeByHR (context, fileInfo) {
    return api.parseCandidateResumeByHR(fileInfo)
  },
  getSalaryList () {
    return api.getSalaryList()
  },
  createApplicationWithResume (context, resumeInfo) {
    return api.createApplicationWithResume(resumeInfo)
  },
  getApplicationResumeInfo (context, applicationId) {
    return api.getApplicationResumeInfo(applicationId)
  },
  updateApplicationResume (context, { applicationId, resumeInfo }) {
    return api.updateApplicationResume(applicationId, resumeInfo)
  },
  hasIdNumberField (context) {
    return api.hasIdNumberField()
  },
  uploadApplicationCandidatePhoto (context, { candidateId, jobId, photo }) {
    return api.uploadApplicationCandidatePhoto(candidateId, jobId, photo)
  },
  handleOpenQuestionUploadedVideo (context, fileInfo) {
    return api.handleOpenQuestionUploadedVideo(fileInfo)
  },
  getOpenQuestionUploadedVideoDuration (context, params) {
    return api.getOpenQuestionUploadedVideoDuration(params)
  },
  getRecruiterQuestionnaire (context, { jobId, params }) {
    return api.getRecruiterQuestionnaire(jobId, params)
  },
  getApplicationQuestionnaire (context, { jobId, params }) {
    return api.getApplicationQuestionnaire(jobId, params)
  },
  getPrescreenQuestionnaire (context, { jobId, params }) {
    return api.getPrescreenQuestionnaire(jobId, params)
  },
  getHeadhunterUploadedCandidateCount (context, params) {
    return api.getHeadhunterUploadedCandidateCount(params)
  },
  getDuplicateCandidateList (context, params) {
    return api.getDuplicateCandidateList(params)
  },
  getHrQuestion (context, jobId) {
    return api.getHrQuestion(jobId)
  },
  checkEmailOrPhoneApplication (context, params) {
    return api.checkEmailOrPhoneApplication(params)
  },
  getCandidateStatusGroupList (context, params) {
    return api.getCandidateStatusGroupList(params)
  },
  changeCandidateStatus (context, statusInfo) {
    return api.changeCandidateStatus(statusInfo)
  },
  getGroupList (context, applicationInfo) {
    return api.getGroupList(applicationInfo)
  },
  saveCandidateGroup (context, groupInfo) {
    return api.saveCandidateGroup(groupInfo)
  },
  moveCandidateGroup (context, groupInfo) {
    return api.moveCandidateGroup(groupInfo)
  },
  getCompanyApplicationList (context, params) {
    return api.getCompanyApplicationList(params)
  },
  getJobApplicationList (context, { jobId, params }) {
    return api.getJobApplicationList(jobId, params)
  },
  createHrInterview (context, interviewInfo) {
    return api.createHrInterview(interviewInfo)
  },
  createHrRating (context, ratingInfo) {
    return api.createHrRating(ratingInfo)
  },
  getHrRatingQuestionnaireResults (context, params) {
    return api.getHrRatingQuestionnaireResults(params)
  },
  copyCandidate (context, params) {
    return api.copyCandidate(params)
  },
  inviteCandidateApplyJob (context, invitation) {
    return api.inviteCandidateApplyJob(invitation)
  },
  getCandidateCanInviteJobList (context, params) {
    return api.getCandidateCanInviteJobList(params)
  },
  addComment (context, comment) {
    return api.addComment(comment)
  },
  contactCandidate (context, contactInfo) {
    return api.contactCandidate(contactInfo)
  },
  sendInviteNotification (context, invitation) {
    return api.sendInviteNotification(invitation)
  },
  inviteOpenQuestion (context, invitation) {
    return api.inviteOpenQuestion(invitation)
  },
  exportCandidateProfilePDF (context, applicationInfo) {
    return api.exportCandidateProfilePDF(applicationInfo)
  },
  getExportCandidateProfilePDFTaskStatus (context, params) {
    return api.getExportCandidateProfilePDFTaskStatus(params)
  },
  exportConsentInfoPDF (context, params) {
    return api.exportConsentInfoPDF(params)
  },
  getExportConsentInfoPDFTaskStatus (context, params) {
    return api.getExportConsentInfoPDFTaskStatus(params)
  },
  exportCandidateProfileWord (context, applicationInfo) {
    return api.exportCandidateProfileWord(applicationInfo)
  },
  createProfileShareLinkCode (context, shareInfo) {
    return api.createProfileShareLinkCode(shareInfo)
  },
  viewApplication (context, { jobId, candidateId }) {
    return api.viewApplication(jobId, candidateId)
  },
  changeAgencyUploadedCandidateStatus (context, info) {
    return api.changeAgencyUploadedCandidateStatus(info)
  },
  getApplicationIdList (context, params) {
    return api.getApplicationIdList(params)
  },
  exportCandidateConsentPDF (context, params) {
    return api.exportCandidateConsentPDF(params)
  },
  getExportCandidateConsentPDFaskStatus (context, params) {
    return api.getExportCandidateConsentPDFaskStatus(params)
  },
  exportApplicationCandidateWord (context, params) {
    return api.exportApplicationCandidateWord(params)
  },
  getExportCandidateWordTaskStatus (context, params) {
    return api.getExportCandidateWordTaskStatus(params)
  },
  sendInviteAnswerOriginCompanyQuestion (context, params) {
    return api.sendInviteAnswerOriginCompanyQuestion(params)
  },
  getAssessmentFitCount (context, params) {
    return api.getAssessmentFitCount(params)
  },
  getProblemSolvingFitCount (context, params) {
    return api.getProblemSolvingFitCount(params)
  },
  getCandidateConsentInfo (context, params) {
    return api.getCandidateConsentInfo(params)
  },
  createGroup (context, params) {
    return api.createGroup(params)
  },
  updateGroup (context, params) {
    return api.updateGroup(params)
  },
  deleteGroup (context, params) {
    return api.deleteGroup(params)
  },
  removeCandidateFromGroup (context, params) {
    return api.removeCandidateFromGroup(params)
  },
  getExportJobApplicationExcelFieldInfo () {
    return api.getExportJobApplicationExcelFieldInfo()
  },
  createExportJobApplicationExcelInfoTask (context, params) {
    return api.createExportJobApplicationExcelInfoTask(params)
  },
  exportCandidateProfilePdf (context, params) {
    return api.exportCandidateProfilePdf(params)
  },
  getExportCandidateProfilePdfTaskStatus (context, params) {
    return api.getExportCandidateProfilePdfTaskStatus(params)
  },
  exportConsentPDF (context, params) {
    return api.exportConsentPDF(params)
  },
  getExportConsentPDFaskStatus (context, params) {
    return api.getExportConsentPDFaskStatus(params)
  },
  exportOriginalResume (context, params) {
    return api.exportOriginalResume(params)
  },
  getExportOriginalResumeTaskStatus (context, params) {
    return api.getExportOriginalResumeTaskStatus(params)
  },
  getApplicationCandidateBaseInfo (context, params) {
    return api.getApplicationCandidateBaseInfo(params)
  },
  getApplicationCandidateResumeInfo (context, params) {
    return api.getApplicationCandidateResumeInfo(params)
  },
  getApplicationOpenQuestionInfo (context, params) {
    return api.getApplicationOpenQuestionInfo(params)
  },
  updateApplicationOpenQuestionInfo (context, { jobId, candidateId, data }) {
    return api.updateApplicationOpenQuestionInfo(jobId, candidateId, data)
  },
  getApplicationCandidateHmRateInfo (context, params) {
    return api.getApplicationCandidateHmRateInfo(params)
  },
  getApplicationCandidateInterviewInfo (context, params) {
    return api.getApplicationCandidateInterviewInfo(params)
  },
  getApplicationCandidateProfileTabInfo (context, params) {
    return api.getApplicationCandidateProfileTabInfo(params)
  },
  getApplicationCandidateActivityInfo (context, params) {
    return api.getApplicationCandidateActivityInfo(params)
  },
  getApplicationCandidateTagInfo (context, params) {
    return api.getApplicationCandidateTagInfo(params)
  },
  getApplicationCandidateSurveyInfo (context, params) {
    return api.getApplicationCandidateSurveyInfo(params)
  },
  getApplicationDuplicateCandidateInfo (context, params) {
    return api.getApplicationDuplicateCandidateInfo(params)
  },
  createExportUniversalApplicationExcelInfoTask (context, params) {
    return api.createExportUniversalApplicationExcelInfoTask(params)
  },
  getJobApplyRequiredInfo (context, jobId) {
    return api.getJobApplyRequiredInfo(jobId)
  },
  inviteCandidateUploadResume (context, params) {
    return api.inviteCandidateUploadResume(params)
  },
  inviteCandidateAiInterview (context, params) {
    return api.inviteCandidateAiInterview(params)
  },
  getApplicationAISummary (context, params) {
    return api.getApplicationAISummary(params)
  },
  getApplicationAIMatchInfo (context, params) {
    return api.getApplicationAIMatchInfo(params)
  },
  sendInviteCandidateOfferLetter (context, params) {
    return api.sendInviteCandidateOfferLetter(params)
  },
  resendInviteCandidateOfferLetter (context, params) {
    return api.resendInviteCandidateOfferLetter(params)
  },
  sendOfferLetterNotice (context, params) {
    return api.sendOfferLetterNotice(params)
  },
  getApplicationCandidateOfferLetterInfo (context, params) {
    return api.getApplicationCandidateOfferLetterInfo(params)
  },
  createExportCandidateOfferLetterInfoTask (context, params) {
    return api.createExportCandidateOfferLetterInfoTask(params)
  },
  getExportCandidateOfferLetterTaskStatus (context, params) {
    return api.getExportCandidateOfferLetterTaskStatus(params)
  },
  createParseResumeInfoByHRTask (context, data) {
    return api.createParseResumeInfoByHRTask(data)
  },
  getParseResumeInfoByHRTaskStatus (context, params) {
    return api.getParseResumeInfoByHRTaskStatus(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
